export default __webpack_public_path__ + "ebb708ef392c56661ccbaa6e7cc0396b.svg";